// Model.js
// -----------------------
// @module Case
define("StellarGrade.ST_NewsletterForm.NewsletterForm.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    return Backbone.Model.extend({
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/NewsletterForm/SuiteScript2/NewsletterForm.Service.ss"
            ),
            true
        )
});
});
